import { Object3D } from 'three';

import { CSS2DObject } from '@/lib/three';

export class Label2d {
  static create(name: string, position: [number, number, number]) {
    const text = document.createElement('div');
    text.id = name;

    const label = new CSS2DObject(text);
    label.position.set(...position);

    return label;
  }

  static updateName(target: Object3D, newName: string) {
    if ('isCSS2DObject' in target && target.isCSS2DObject) {
      target.name = newName;
      (target as CSS2DObject).element.id = newName;
    }
  }
}
